module.exports = __webpack_public_path__ + "static/media/lock.4bc23da3.png";